import Cookies from 'js-cookie'
import { LoggerFunction } from 'shared/types/logger'
import { CommentSortEnum, CommentSortOptions } from 'modules/comments/types'

const COMMENT_SORT_PREFERENCE_KEY = 'comment_sort_preference'

export const getCommentSortPreference = (logger: LoggerFunction): CommentSortEnum | null => {
  try {
    const saved = Cookies.get(COMMENT_SORT_PREFERENCE_KEY)
    if (saved && Object.values(CommentSortOptions).includes(saved as CommentSortEnum)) {
      return saved as CommentSortEnum
    }
  } catch (error) {
    logger('Failed to get comment sort preference', error as Error)
  }

  return null
}

export const saveCommentSortPreference = (
  sortOption: CommentSortEnum,
  logger: LoggerFunction,
): void => {
  try {
    Cookies.set(COMMENT_SORT_PREFERENCE_KEY, sortOption, {
      expires: 365,
      secure: process.env.NODE_ENV === 'production',
      sameSite: 'lax',
    })
  } catch (error) {
    logger('Failed to save comment sort preference', error as Error)
  }
}
